import type { EstadoOrdenCorte } from "./api";
import { Badge, type BadgeTone } from "../../components/ui";

// Mapa estado → tono (DESIGN §2.4). Pendiente y Anulada comparten `slate`
// (ambos estados neutros; el label los distingue).
const TONES: Record<EstadoOrdenCorte, BadgeTone> = {
  Pendiente: "slate",
  Notificada: "brand",
  EnRuta: "amber",
  Cortada: "rose",
  Repuesta: "emerald",
  Anulada: "slate",
};

// "Pendiente" es el nombre interno; en pantalla es "Orden abierta", el mismo
// que usa Morosidad (el agua sigue llegando, auditoría UX-13).
export const ETIQUETA_ESTADO_CORTE: Record<EstadoOrdenCorte, string> = {
  Pendiente: "Orden abierta",
  Notificada: "Notificada",
  EnRuta: "En ruta",
  Cortada: "Cortada",
  Repuesta: "Repuesta",
  Anulada: "Anulada",
};

export function EstadoCorteBadge({
  estado,
}: {
  estado: EstadoOrdenCorte;
}): JSX.Element {
  return <Badge tone={TONES[estado]}>{ETIQUETA_ESTADO_CORTE[estado]}</Badge>;
}
